import React from "react";
import Hubspot from "./Hubspot";

let CompanyHubspot = () => {
  return (
    <div className="py-10">
      <h3 className={"uppercase pt-5 border-t border-grey my-5"}>
        Manage Hubspot
      </h3>
      <div className={"col-w-full md:col-w-1/3"}>
        <Hubspot />
      </div>
    </div>
  );
};

export default CompanyHubspot;
